import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Edit2, Trash2, Package } from "lucide-react";

export function IngredientsTab({ items, onEdit, onDelete }) {
  if (items.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <Package className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">Sin ingredientes. Crea el primero!</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid gap-3">
      {items.map(item => (
        <Card key={item.id} className="group" data-testid={`ingredient-${item.id}`}>
          <CardContent className="flex items-center justify-between p-4">
            <div>
              <h3 className="font-semibold">{item.name}</h3>
              <p className="text-sm text-muted-foreground">
                Min: {item.min_quantity} {item.unit} | {item.cost_per_unit?.toFixed(2)}EUR/{item.unit}
                {item.supplier && ` | ${item.supplier}`}
              </p>
            </div>
            <div className="flex items-center gap-3">
              <div className="text-right">
                <p className={`text-2xl font-bold ${item.current_quantity <= item.min_quantity ? "text-yellow-500" : ""}`}>
                  {item.current_quantity}
                </p>
                <p className="text-sm text-muted-foreground">{item.unit}</p>
              </div>
              <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <Button variant="ghost" size="icon" onClick={() => onEdit(item)}>
                  <Edit2 className="w-4 h-4" />
                </Button>
                <Button variant="ghost" size="icon" onClick={() => onDelete(item.id)}>
                  <Trash2 className="w-4 h-4 text-red-500" />
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
